import { render } from "./SidebarNavGroup.vue?vue&type=template&id=543efe75&scoped=true&lang=pug"
import script from "./SidebarNavGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavGroup.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavGroup.vue?vue&type=style&index=0&id=543efe75&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543efe75"]])

export default __exports__